export default __webpack_public_path__ + "static/media/Users.bd8f6906.png";